(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("mobx-react"), require("mobx"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "mobx-react", "mobx"], factory);
	else if(typeof exports === 'object')
		exports["rSliderLib"] = factory(require("react"), require("prop-types"), require("mobx-react"), require("mobx"));
	else
		root["rSliderLib"] = factory(root["React"], root["prop-types"], root["mobx-react"], root["mobx"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition